module.exports = __webpack_public_path__ + "h5/img/cs_23.602c422d.jpeg";